/* so-analytics-events.js — P0-13 (2026-09-28). Theme events for the GA4 custom pixel (analytics/TRACKING-PLAN.md,
   "Custom event contract"). Publishes ONLY:
     so:card_clicked     {surface, list_name, position, target, product_id}
     so:quick_add_opened {surface, product_id}
   (the so:age_gate_* events live in sections/so-age-gate.liquid).
   Rules: whitelisted keys only, no free text, never throw, never block, never await.
   surface is where the SHOPPER is (the page), not how the card was rendered — rails such as recently-viewed are
   fetched through the search route, so Liquid's template context is not trustworthy for them.
   list_name: collection surface = the collection handle (data-so-list, from product-card's `collection`);
   elsewhere the section key of the rail (e.g. fc_bestsellers, recommendations). position = 1-based index of the
   card among the cards of its list, as displayed. Loaded from snippets/quick-add-drawer.liquid (every page). */
(function () {
  if (window.__soAnalyticsEvents) return;
  window.__soAnalyticsEvents = true;

  function publish(name, payload) {
    try { window.Shopify && Shopify.analytics && Shopify.analytics.publish && Shopify.analytics.publish(name, payload); } catch (e) {}
  }

  function surface() {
    var p = location.pathname.replace(/\/+$/, '') || '/';
    if (document.querySelector('.so-404')) return '404';
    if (p === '/') return 'home_rail';
    if (p.indexOf('/products/') !== -1) return 'pdp_rail';
    if (p.indexOf('/collections/') === 0 || p === '/collections') return 'collection';
    if (p.indexOf('/search') === 0) return 'search';
    if (p === '/pages/your-picks') return 'your_picks';
    return null;   // not a surface in the contract
  }

  function sectionKey(el) {
    var s = el.closest('.shopify-section');
    var id = s && s.id ? s.id.replace(/^shopify-section-/, '') : '';
    var i = id.lastIndexOf('__');
    id = i === -1 ? id : id.slice(i + 2);
    return /^[A-Za-z0-9_-]{1,60}$/.test(id) ? id : '';
  }

  function position(card) {
    var list = card.closest('ul, ol, [role="list"]') || card.closest('.shopify-section') || document;
    var cards = list.querySelectorAll('product-card.card');
    for (var i = 0; i < cards.length; i++) if (cards[i] === card) return i + 1;
    return 0;
  }

  function pid(card) {
    var v = card && card.getAttribute('data-so-pid');
    return v && /^\d+$/.test(v) ? v : '';
  }

  function cardPayload(card, target) {
    var s = surface();
    if (!s) return null;
    var p = { surface: s };
    var list = s === 'collection' ? (card.getAttribute('data-so-list') || sectionKey(card)) : sectionKey(card);
    if (list) p.list_name = list;
    var pos = position(card);
    if (pos) p.position = pos;
    p.target = target;
    var id = pid(card);
    if (id) p.product_id = id;
    return p;
  }

  // One event per click on a card's title, image or quick-add button.
  document.addEventListener('click', function (e) {
    try {
      var t = e.target;
      if (!t || typeof t.closest !== 'function') return;
      var card = t.closest('product-card.card');
      if (!card) return;
      var target = null;
      if (t.closest('.js-quick-add, .card__quick-add [name="add"]')) target = 'quick_add';
      else if (t.closest('.card__main-image') || (t.closest('.js-prod-link') && t.closest('.card__media'))) target = 'image';
      else if (t.closest('.js-prod-link')) target = 'title';
      if (!target) return;
      var p = cardPayload(card, target);
      if (p) publish('so:card_clicked', p);
    } catch (err) {}
  }, { capture: true, passive: true });

  // The quick-add drawer really opened (SideDrawer fires on:quickbuy:after-open; drawer.opener = the button).
  document.addEventListener('on:quickbuy:after-open', function (e) {
    try {
      var drawer = e.target;
      var opener = drawer && drawer.opener;
      var s = surface();
      if (opener && opener.closest && opener.closest('cart-drawer')) s = 'cart_drawer';
      if (!s) return;
      var p = { surface: s };
      var card = opener && opener.closest && opener.closest('product-card.card');
      var id = pid(card);
      if (id) p.product_id = id;
      publish('so:quick_add_opened', p);
    } catch (err) {}
  });
})();
